var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.908 11.908"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 31",
    d: "M11.909 11.2l-.707.708L0 .707l.708-.708z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 32",
    d: "M.708 11.909L0 11.2 11.202.001l.707.706z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMS45MDgiIGhlaWdodD0iMTEuOTA4IiB2aWV3Qm94PSIwIDAgMTEuOTA4IDExLjkwOCI+CiAgPGcgaWQ9Ikdyb3VwXzc2IiBkYXRhLW5hbWU9Ikdyb3VwIDc2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNS4yNDcgNS45NTQpIHJvdGF0ZSgtNDUpIj4KICAgIDxwYXRoIGlkPSJMaW5lXzMxIiBkYXRhLW5hbWU9IkxpbmUgMzEiIGQ9Ik0uNSwxNS44NDFoLTFWMGgxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy45MjEpIi8+CiAgICA8cGF0aCBpZD0iTGluZV8zMiIgZGF0YS1uYW1lPSJMaW5lIDMyIiBkPSJNLjUsMTUuODQxaC0xVjBoMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1Ljg0MSA3LjkyMSkgcm90YXRlKDkwKSIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgCross as ReactComponent };